export const formatHours = (time) => {
  if (!time) return "";

  const parts = time.split(":");

  const hours = parts[0] || "00";
  const minutes = parts[1] || "00";

  return `${hours}h ${minutes}m`;
};

export const OFFICE_LOCATION = {
  latitude: 23.0787058,
  longitude: 72.4987273,
};

export const ALLOWED_RADIUS_KM = 1;

export const calculateDistanceInKm = (
  latitude1,
  longitude1,
  latitude2,
  longitude2
) => {
  const earthRadiusKm = 6371;

  const dLat = ((latitude2 - latitude1) * Math.PI) / 180;
  const dLon = ((longitude2 - longitude1) * Math.PI) / 180;

  const lat1Rad = (latitude1 * Math.PI) / 180;
  const lat2Rad = (latitude2 * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1Rad) *
      Math.cos(lat2Rad) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadiusKm * c;
};